var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center","height":"100%"}},[_c('div',{staticClass:"text-center"},[_c('h1',[_vm._v("NOT FOUND")]),_c('h2',[_vm._v(_vm._s(_vm.$route.path))])])])}
var staticRenderFns = []

export { render, staticRenderFns }